<template>
  <div>
    <nav class="navbar px-4 py-2" v-if="!(inIframe && isSiteMsa)">
        <div class="container">
              <a class="navbar-brand text-white fw-bold" href="/home">
                  <img :src="logo" alt="logo">
              </a>
              <div class="navbar-start">
                <Link
                  :href="'/account'+this.redirect_params"
                  class="btn-log"
                  v-if="user && allowSignIn">
                  {{ this.redirected ? this.account_title : "Mon compte"}}
                </Link>
              </div>            
              <div v-if="allowSignIn && !this.redirected">
                <div class="">
                  <button
                    class="btn-log"
                    @click="toggleModal('#auth-modal')"
                    id="auth-button"
                    v-if="!user && withAuth"
                  >
                    Je m'authentifie
                  </button>
                  <button class="button is-light" v-if="user" @click="logout">
                    Me déconnecter
                  </button>
                </div>
              </div>
              <div class="navbar-item"  v-if="this.redirected">
                <div class="buttons">
                  <a class="button is-danger" @click="cancel_redirect_rdv()">{{ this.fo_config['text']['RDV_BY_REDIRECT_btn_cancel'] }}</a>
                </div>
              </div>
        </div>
    </nav>
    <!-- <nav id="layout_nav"
      class="navbar has-shadow is-fixed-top"
      role="navigation"
      aria-label="main navigation"
      v-if="!(inIframe && isSiteMsa)"
    >
      <div class="navbar-brand">
        <Link v-if="logo" href="/">
          <img :src="logo" alt="" id="logo-img" />
        </Link>
        <span class="navbar-item slogan" v-else-if="slogan">
          {{ slogan }}
        </span>
        <span class="navbar-item slogan" v-else> My simply agenda </span>

        <a
          role="button"
          class="navbar-burger"
          aria-label="menu"
          aria-expanded="false"
          data-target="navbarBasicExample"
          @click="toggleMenu"
        >
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
        </a>
      </div>

      <div id="navbarBasicExample" class="navbar-menu">
        <div class="navbar-start">
          <Link v-if="!this.redirected" class="navbar-item is-unselectable has-text-info" href="/">
            Accueil
          </Link>

          <Link
            class="navbar-item is-unselectable has-text-info"
            :href="this.redirected ? '/redirect/times'+this.redirect_params : '/ressources'"
            v-if="allowSignIn && !this.redirected || this.redirected"
          >
            Prendre rendez-vous
          </Link>
          <Link
            :href="'/account'+this.redirect_params"
            class="navbar-item is-unselectable has-text-info"
            v-if="user && allowSignIn">
            {{ this.redirected ? this.account_title : "Mon compte"}}
          </Link>
        </div>

        <div class="navbar-end">
          <div class="navbar-item" v-if="allowSignIn && !this.redirected">
            <div class="buttons">
              <a
                class="button is-info is-rounded shinny-effect"
                @click="toggleModal('#auth-modal')"
                id="auth-button"
                v-if="!user && withAuth"
              >
                Je m'authentifie
              </a>
              <a class="button is-light" v-if="user" @click="logout">
                Me déconnecter
              </a>
            </div>
          </div>
          <div class="navbar-item"  v-if="this.redirected">
            <div class="buttons">
              <a class="button is-danger" @click="cancel_redirect_rdv()">{{ this.fo_config['text']['RDV_BY_REDIRECT_btn_cancel'] }}</a>
            </div>
          </div>
        </div>
      </div>
    </nav> -->
  </div>
  <div>
    <auth-modal v-on:userLogin="onUserLogin" v-bind:withAuth="withAuth" :autoBooking="autoBooking" v-on:submitWithoutAuth="(client) => $emit('submitWithoutAuth', client)"></auth-modal>
    <slot></slot>
  </div>

      <!-- Footer -->
      <footer class="footer">
        <div class="contaner">
            <div class="footer-content">
                <div class="container">
                    <div class="row">
                        <div class="col-lg-4">
                            <div class="footer-logo">
                                <a class="navbar-brand" href="#">
                                  <img :src="logo" alt="logo">
                                </a>
                            </div>
                        </div>
                        <div class="col-lg-4">
                            <div class="footer-social">
                                <ul>
                                    <li><a href="#">
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M4 12C4.00014 10.4605 4.44451 8.95364 5.27979 7.66038C6.11506 6.36712 7.30576 5.34234 8.70901 4.70901C10.1123 4.07568 11.6684 3.8607 13.1908 4.08987C14.7132 4.31904 16.1372 4.98262 17.2918 6.00099C18.4464 7.01936 19.2826 8.34926 19.7002 9.83111C20.1177 11.313 20.0988 12.8838 19.6457 14.3552C19.1926 15.8265 18.3246 17.1359 17.1458 18.1262C15.967 19.1165 14.5275 19.7456 13 19.938V14H15C15.2652 14 15.5196 13.8946 15.7071 13.7071C15.8946 13.5196 16 13.2652 16 13C16 12.7348 15.8946 12.4804 15.7071 12.2929C15.5196 12.1054 15.2652 12 15 12H13V10C13 9.73478 13.1054 9.48043 13.2929 9.29289C13.4804 9.10536 13.7348 9 14 9H14.5C14.7652 9 15.0196 8.89464 15.2071 8.70711C15.3946 8.51957 15.5 8.26522 15.5 8C15.5 7.73478 15.3946 7.48043 15.2071 7.29289C15.0196 7.10536 14.7652 7 14.5 7H14C13.2044 7 12.4413 7.31607 11.8787 7.87868C11.3161 8.44129 11 9.20435 11 10V12H9C8.73478 12 8.48043 12.1054 8.29289 12.2929C8.10536 12.4804 8 12.7348 8 13C8 13.2652 8.10536 13.5196 8.29289 13.7071C8.48043 13.8946 8.73478 14 9 14H11V19.938C9.06661 19.6944 7.28861 18.7535 5.99975 17.292C4.7109 15.8304 3.99982 13.9487 4 12ZM12 22C17.523 22 22 17.523 22 12C22 6.477 17.523 2 12 2C6.477 2 2 6.477 2 12C2 17.523 6.477 22 12 22Z" fill="#FBBC00"/>
                                        </svg>
                                        </a>
                                    </li>
                                    <li><a href="#">
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M7.8 2H16.2C19.4 2 22 4.6 22 7.8V16.2C22 17.7383 21.3889 19.2135 20.3012 20.3012C19.2135 21.3889 17.7383 22 16.2 22H7.8C4.6 22 2 19.4 2 16.2V7.8C2 6.26174 2.61107 4.78649 3.69878 3.69878C4.78649 2.61107 6.26174 2 7.8 2ZM7.6 4C6.64522 4 5.72955 4.37928 5.05442 5.05442C4.37928 5.72955 4 6.64522 4 7.6V16.4C4 18.39 5.61 20 7.6 20H16.4C17.3548 20 18.2705 19.6207 18.9456 18.9456C19.6207 18.2705 20 17.3548 20 16.4V7.6C20 5.61 18.39 4 16.4 4H7.6ZM17.25 5.5C17.5815 5.5 17.8995 5.6317 18.1339 5.86612C18.3683 6.10054 18.5 6.41848 18.5 6.75C18.5 7.08152 18.3683 7.39946 18.1339 7.63388C17.8995 7.8683 17.5815 8 17.25 8C16.9185 8 16.6005 7.8683 16.3661 7.63388C16.1317 7.39946 16 7.08152 16 6.75C16 6.41848 16.1317 6.10054 16.3661 5.86612C16.6005 5.6317 16.9185 5.5 17.25 5.5ZM12 7C13.3261 7 14.5979 7.52678 15.5355 8.46447C16.4732 9.40215 17 10.6739 17 12C17 13.3261 16.4732 14.5979 15.5355 15.5355C14.5979 16.4732 13.3261 17 12 17C10.6739 17 9.40215 16.4732 8.46447 15.5355C7.52678 14.5979 7 13.3261 7 12C7 10.6739 7.52678 9.40215 8.46447 8.46447C9.40215 7.52678 10.6739 7 12 7ZM12 9C11.2044 9 10.4413 9.31607 9.87868 9.87868C9.31607 10.4413 9 11.2044 9 12C9 12.7956 9.31607 13.5587 9.87868 14.1213C10.4413 14.6839 11.2044 15 12 15C12.7956 15 13.5587 14.6839 14.1213 14.1213C14.6839 13.5587 15 12.7956 15 12C15 11.2044 14.6839 10.4413 14.1213 9.87868C13.5587 9.31607 12.7956 9 12 9Z" fill="#FBBC00"/>
                                            </svg>                                                                                               
                                        </a>
                                    </li>
                                    <li><a href="#"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M18 3C18.7956 3 19.5587 3.31607 20.1213 3.87868C20.6839 4.44129 21 5.20435 21 6V18C21 18.7956 20.6839 19.5587 20.1213 20.1213C19.5587 20.6839 18.7956 21 18 21H6C5.20435 21 4.44129 20.6839 3.87868 20.1213C3.31607 19.5587 3 18.7956 3 18V6C3 5.20435 3.31607 4.44129 3.87868 3.87868C4.44129 3.31607 5.20435 3 6 3H18ZM18 5H6C5.73478 5 5.48043 5.10536 5.29289 5.29289C5.10536 5.48043 5 5.73478 5 6V18C5 18.2652 5.10536 18.5196 5.29289 18.7071C5.48043 18.8946 5.73478 19 6 19H18C18.2652 19 18.5196 18.8946 18.7071 18.7071C18.8946 18.5196 19 18.2652 19 18V6C19 5.73478 18.8946 5.48043 18.7071 5.29289C18.5196 5.10536 18.2652 5 18 5ZM8 10C8.24493 10 8.48134 10.09 8.66437 10.2527C8.84741 10.4155 8.96434 10.6397 8.993 10.883L9 11V16C8.99972 16.2549 8.90212 16.5 8.72715 16.6854C8.55218 16.8707 8.31305 16.9822 8.05861 16.9972C7.80416 17.0121 7.55362 16.9293 7.35817 16.7657C7.16271 16.6021 7.0371 16.3701 7.007 16.117L7 16V11C7 10.7348 7.10536 10.4804 7.29289 10.2929C7.48043 10.1054 7.73478 10 8 10ZM11 9C11.2342 8.99996 11.461 9.08213 11.6408 9.23216C11.8206 9.3822 11.9421 9.59059 11.984 9.821C12.1854 9.70468 12.3934 9.60017 12.607 9.508C13.274 9.223 14.273 9.066 15.175 9.349C15.648 9.499 16.123 9.779 16.475 10.256C16.79 10.681 16.96 11.198 16.994 11.779L17 12V16C16.9997 16.2549 16.9021 16.5 16.7272 16.6854C16.5522 16.8707 16.313 16.9822 16.0586 16.9972C15.8042 17.0121 15.5536 16.9293 15.3582 16.7657C15.1627 16.6021 15.0371 16.3701 15.007 16.117L15 16V12C15 11.67 14.92 11.516 14.868 11.445C14.7933 11.3523 14.6904 11.2863 14.575 11.257C14.227 11.147 13.726 11.205 13.393 11.347C12.893 11.561 12.435 11.897 12.123 12.208L12 12.34V16C11.9997 16.2549 11.9021 16.5 11.7272 16.6854C11.5522 16.8707 11.313 16.9822 11.0586 16.9972C10.8042 17.0121 10.5536 16.9293 10.3582 16.7657C10.1627 16.6021 10.0371 16.3701 10.007 16.117L10 16V10C10 9.73478 10.1054 9.48043 10.2929 9.29289C10.4804 9.10536 10.7348 9 11 9ZM8 7C8.26522 7 8.51957 7.10536 8.70711 7.29289C8.89464 7.48043 9 7.73478 9 8C9 8.26522 8.89464 8.51957 8.70711 8.70711C8.51957 8.89464 8.26522 9 8 9C7.73478 9 7.48043 8.89464 7.29289 8.70711C7.10536 8.51957 7 8.26522 7 8C7 7.73478 7.10536 7.48043 7.29289 7.29289C7.48043 7.10536 7.73478 7 8 7Z" fill="#FBBC00"/>
                                        </svg>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class="col-lg-4">
                            <div class="footer-links">
                                <ul>
                                    <li><a href="#">Terms & Conditions ,</a></li>
                                    <li><a href="#">Privacy Policy ,</a></li>
                                    <li><a href="#">Sitemap</a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="footer-copyright">
            <span>© 2025 my simply agenda, Votre temps est précieux, optimisez le !</span>
        </div>
    </footer>
  <!-- <footer class="footer" v-if="!inIframe">
    <div class="content has-text-centered">
      <div class="columns">
        <div class="copyright column">
          <a href="https://mysimplyagenda.com" target="_blank">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 225.5 22.85">
              <g>
                <path
                  class="cls-1"
                  d="M35.94,11.29c-.18-.18-.44-.27-.77-.27h-3.34c-.34,0-.59,.09-.77,.27s-.27,.44-.27,.77v4.65c0,.23-.11,.35-.34,.35h-.84c-.22,0-.34-.12-.34-.35v-4.86c0-.7,.18-1.23,.55-1.61,.37-.38,.9-.56,1.61-.56h3.66c.91,0,1.54,.32,1.89,.96,.34-.64,.97-.96,1.89-.96h3.66c.7,0,1.24,.19,1.61,.56s.55,.91,.55,1.61v4.86c0,.23-.11,.35-.34,.35h-.83c-.23,0-.35-.12-.35-.35v-4.65c0-.34-.09-.6-.27-.77-.18-.18-.44-.27-.77-.27h-3.34c-.34,0-.59,.09-.77,.27-.18,.18-.27,.44-.27,.77v4.65c0,.23-.11,.35-.34,.35h-.83c-.23,0-.35-.12-.35-.35v-4.65c0-.34-.09-.6-.27-.77Z"
                />
                <path
                  class="cls-1"
                  d="M48.5,13.24c.18,.18,.44,.26,.77,.26h6.85c.34,0,.59-.09,.77-.26s.27-.44,.27-.78v-2.43c0-.23,.11-.35,.34-.35h.83c.23,0,.35,.12,.35,.35v2.64c0,.69-.18,1.23-.55,1.61-.37,.38-.9,.57-1.61,.57h-3.07v1.85c0,.23-.12,.35-.35,.35h-.83c-.22,0-.34-.12-.34-.35v-1.85h-3.07c-.7,0-1.24-.19-1.61-.57-.37-.38-.56-.92-.56-1.61v-2.64c0-.23,.12-.35,.35-.35h.83c.23,0,.35,.12,.35,.35v2.43c0,.34,.09,.6,.27,.78Z"
                />
                <path
                  class="cls-1"
                  d="M67.25,11.8v.14c0,.27,.08,.47,.23,.59,.15,.12,.39,.18,.71,.18h6.73c.35,0,.67,.03,.95,.09,.28,.06,.52,.17,.71,.32,.19,.15,.34,.34,.45,.57,.11,.24,.16,.52,.16,.87v.62c0,.34-.05,.64-.16,.87-.1,.24-.25,.43-.45,.58-.19,.15-.43,.25-.71,.32-.28,.06-.6,.09-.95,.09h-8.69c-.22,0-.34-.12-.34-.35v-.65c0-.22,.11-.34,.34-.34h8.49c.32,0,.56-.06,.71-.18,.15-.12,.23-.32,.23-.6v-.14c0-.27-.08-.47-.23-.59-.15-.12-.39-.18-.71-.18h-6.73c-.35,0-.67-.03-.94-.09s-.51-.17-.71-.32c-.19-.15-.34-.34-.45-.57-.1-.24-.16-.52-.16-.87v-.62c0-.34,.05-.64,.16-.87,.11-.24,.25-.43,.45-.58,.19-.15,.43-.25,.71-.32s.59-.09,.94-.09h8.58c.23,0,.35,.12,.35,.35v.65c0,.22-.12,.34-.35,.34h-8.38c-.62,0-.94,.26-.94,.78Z"
                />
                <path
                  class="cls-1"
                  d="M80.84,16.71c0,.23-.12,.35-.35,.35h-.83c-.23,0-.35-.12-.35-.35v-6.68c0-.23,.12-.35,.35-.35h.83c.23,0,.35,.12,.35,.35v6.68Z"
                />
                <path
                  class="cls-1"
                  d="M89.93,11.29c-.18-.18-.44-.27-.77-.27h-3.34c-.34,0-.59,.09-.77,.27s-.27,.44-.27,.77v4.65c0,.23-.11,.35-.34,.35h-.84c-.22,0-.34-.12-.34-.35v-4.86c0-.7,.18-1.23,.55-1.61,.37-.38,.9-.56,1.61-.56h3.66c.91,0,1.54,.32,1.89,.96,.34-.64,.97-.96,1.89-.96h3.66c.7,0,1.24,.19,1.61,.56s.55,.91,.55,1.61v4.86c0,.23-.11,.35-.34,.35h-.83c-.23,0-.35-.12-.35-.35v-4.65c0-.34-.09-.6-.27-.77-.18-.18-.44-.27-.77-.27h-3.34c-.34,0-.59,.09-.77,.27-.18,.18-.27,.44-.27,.77v4.65c0,.23-.11,.35-.34,.35h-.83c-.23,0-.35-.12-.35-.35v-4.65c0-.34-.09-.6-.27-.77Z"
                />
                <path
                  class="cls-1"
                  d="M101.06,10.03c0-.23,.12-.35,.35-.35h8.57c.72,0,1.27,.18,1.65,.54s.56,.89,.56,1.6v.61c0,.71-.19,1.24-.56,1.6-.38,.36-.93,.54-1.65,.54h-7.39v2.14c0,.23-.12,.35-.35,.35h-.83c-.23,0-.35-.12-.35-.35v-6.68Zm9.62,1.94c0-.32-.08-.55-.24-.71-.16-.16-.42-.24-.78-.24h-7.07v2.2h7.07c.36,0,.62-.08,.78-.23,.16-.15,.24-.39,.24-.71v-.32Z"
                />
                <path
                  class="cls-1"
                  d="M115.95,15.45c.18,.18,.44,.27,.77,.27h7.92c.23,0,.35,.11,.35,.34v.65c0,.23-.12,.35-.35,.35h-8.32c-.7,0-1.24-.19-1.61-.56-.37-.38-.55-.91-.55-1.61v-4.86c0-.23,.11-.35,.34-.35h.84c.22,0,.34,.12,.34,.35v4.65c0,.34,.09,.6,.27,.77Z"
                />
                <path
                  class="cls-1"
                  d="M127.86,13.24c.18,.18,.44,.26,.77,.26h6.85c.34,0,.59-.09,.77-.26s.27-.44,.27-.78v-2.43c0-.23,.11-.35,.34-.35h.83c.23,0,.35,.12,.35,.35v2.64c0,.69-.18,1.23-.55,1.61-.37,.38-.9,.57-1.61,.57h-3.07v1.85c0,.23-.12,.35-.35,.35h-.83c-.22,0-.34-.12-.34-.35v-1.85h-3.07c-.7,0-1.24-.19-1.61-.57-.37-.38-.56-.92-.56-1.61v-2.64c0-.23,.12-.35,.35-.35h.83c.23,0,.35,.12,.35,.35v2.43c0,.34,.09,.6,.27,.78Z"
                />
                <path
                  class="cls-1"
                  d="M145.35,11.85c0-.7,.18-1.23,.55-1.61,.37-.38,.9-.56,1.61-.56h7.17c.7,0,1.24,.19,1.61,.56s.56,.91,.56,1.61v4.86c0,.23-.12,.35-.35,.35h-.83c-.23,0-.35-.12-.35-.35v-1.92h-8.46v1.92c0,.23-.11,.35-.34,.35h-.84c-.22,0-.34-.12-.34-.35v-4.86Zm9.98,.21c0-.34-.09-.6-.26-.77-.18-.18-.44-.27-.78-.27h-6.37c-.34,0-.6,.09-.77,.27-.18,.18-.27,.44-.27,.77v1.39h8.46v-1.39Z"
                />
                <path
                  class="cls-1"
                  d="M170.76,15.19c0,.34-.05,.64-.16,.87s-.26,.43-.45,.58-.44,.25-.72,.32c-.28,.06-.59,.09-.94,.09h-7.18c-.7,0-1.24-.19-1.61-.56-.37-.38-.55-.91-.55-1.61v-3.03c0-.7,.18-1.23,.55-1.61,.37-.38,.9-.56,1.61-.56h8.68c.23,0,.35,.12,.35,.35v.65c0,.22-.12,.34-.35,.34h-8.28c-.34,0-.6,.09-.77,.27-.18,.18-.27,.44-.27,.77v2.61c0,.34,.09,.6,.27,.77,.18,.18,.44,.27,.77,.27h6.58c.32,0,.56-.06,.71-.18s.23-.32,.23-.6v-.92h-3.24c-.23,0-.35-.12-.35-.35v-.61c0-.23,.12-.35,.35-.35h4.42c.23,0,.35,.12,.35,.35v2.13Z"
                />
                <path
                  class="cls-1"
                  d="M174.38,14.68c0,.34,.09,.6,.27,.77,.18,.18,.44,.27,.77,.27h8.33c.23,0,.35,.11,.35,.34v.65c0,.23-.12,.35-.35,.35h-8.73c-.7,0-1.24-.19-1.61-.56-.37-.38-.55-.91-.55-1.61v-3.03c0-.7,.18-1.23,.55-1.61,.37-.38,.9-.56,1.61-.56h8.73c.23,0,.35,.12,.35,.35v.65c0,.22-.12,.34-.35,.34h-8.33c-.34,0-.6,.09-.77,.27-.18,.18-.27,.44-.27,.77v.65h8.32c.23,0,.35,.12,.35,.35v.61c0,.23-.12,.35-.35,.35h-8.32v.65Z"
                />
                <path
                  class="cls-1"
                  d="M186.77,10.25c.37-.38,.9-.56,1.61-.56h7.12c.7,0,1.24,.19,1.61,.56s.56,.91,.56,1.61v4.86c0,.23-.12,.35-.35,.35h-.83c-.23,0-.35-.12-.35-.35v-4.65c0-.34-.09-.6-.26-.77-.18-.18-.44-.27-.78-.27h-6.32c-.34,0-.6,.09-.77,.27-.18,.18-.27,.44-.27,.77v4.65c0,.23-.11,.35-.34,.35h-.84c-.22,0-.34-.12-.34-.35v-4.86c0-.7,.18-1.23,.55-1.61Z"
                />
                <path
                  class="cls-1"
                  d="M200.08,10.03c0-.23,.12-.35,.35-.35h8.66c.82,0,1.43,.22,1.86,.65,.42,.43,.64,1.05,.64,1.86v2.36c0,.81-.21,1.43-.64,1.86-.42,.43-1.04,.65-1.86,.65h-8.66c-.23,0-.35-.12-.35-.35v-6.68Zm9.99,2.35c0-.44-.12-.78-.35-1.01-.23-.23-.57-.35-1.02-.35h-7.09v4.7h7.09c.45,0,.79-.12,1.02-.35,.23-.23,.35-.57,.35-1.01v-1.98Z"
                />
                <path
                  class="cls-1"
                  d="M213.87,11.85c0-.7,.18-1.23,.55-1.61,.37-.38,.9-.56,1.61-.56h7.17c.7,0,1.24,.19,1.61,.56s.56,.91,.56,1.61v4.86c0,.23-.12,.35-.35,.35h-.83c-.23,0-.35-.12-.35-.35v-1.92h-8.46v1.92c0,.23-.11,.35-.34,.35h-.84c-.22,0-.34-.12-.34-.35v-4.86Zm9.98,.21c0-.34-.09-.6-.26-.77-.18-.18-.44-.27-.78-.27h-6.37c-.34,0-.6,.09-.77,.27-.18,.18-.27,.44-.27,.77v1.39h8.46v-1.39Z"
                />
              </g>
              <g>
                <path
                  class="cls-1"
                  d="M11.42,22.72C5.19,22.72,.12,17.66,.12,11.42S5.19,.12,11.42,.12h11.3V11.42c0,6.23-5.07,11.3-11.3,11.3Zm0-20.43C6.39,2.29,2.29,6.39,2.29,11.42s4.1,9.13,9.13,9.13,9.13-4.1,9.13-9.13V2.29H11.42Z"
                />
                <path
                  class="cls-1"
                  d="M11.42,16.68c-3.23,0-5.85-2.62-5.85-5.85s2.63-5.85,5.85-5.85,5.85,2.63,5.85,5.85-2.63,5.85-5.85,5.85Zm0-9.02c-1.75,0-3.17,1.42-3.17,3.17s1.42,3.17,3.17,3.17,3.17-1.42,3.17-3.17-1.42-3.17-3.17-3.17Z"
                />
              </g>
            </svg>
          </a>
        </div>
      </div>
      <div class="column">
        <div class="copyright">
          <p>Votre temps est précieux, optimisez le !</p>
        </div>
      </div>
    </div>
  </footer> -->
</template>

<style scoped>
.copyright svg {
  width: 300px;
  height: auto;
}

.copyright svg .cls-1 {
  fill: #271c49;
}

.buttons a {
    background-color: var(--btn-primary-bg-color);
    color: var(--btn-primary-text-color);
}

.buttons a:hover {
    background-color: var(--btn-primary-bg-color-hover);
    color: var(--btn-primary-text-color);
}
</style>

<script>
import { Inertia } from "@inertiajs/inertia";
import axios from 'axios'
import { Link } from "@inertiajs/inertia-vue3";
import AuthModal from "./Profile/AuthModal.vue";
import { toast } from "bulma-toast";

export default {
  name: "Layout",
  props: ["settingsConfig","config","fo_config", "account_title"],
  components: { AuthModal, Link },
  emits: ['submitWithoutAuth'],
  computed: {
    allowSignIn() {
      return !this.$page.props.config?.disabled_fo_signin;
    },
    inIframe() {
      try {
        return window.self !== window.top;
      } catch (e) {
        console.log(e);
        return true;
      }
    },
    isSiteMsa() {
      return document.location.hostname === "teammsa.prordv.com";
    },
    logo() {
      return this.$page.props.logo;
    },
    slogan() {
      return this.$page.props.slogan;
    },
    hostname() {
      return window.location.hostname;
    },
    user() {
      return this.$page.props.auth.user?.client?.[0];
    },
    withAuth(){
        return !(this.settingsConfig && this.settingsConfig["BOOK_WITHOUT_SUBSCRIPTION"] && this.settingsConfig["BOOK_WITHOUT_SUBSCRIPTION"] == 1);
    },
    autoBooking(){
        return (this.settingsConfig && this.settingsConfig["AUTO_BOOKING"] && this.settingsConfig["AUTO_BOOKING"] == 1);
    },
    redirected(){
      return this.fo_config && (this.fo_config['redirected'] == 1);
    },
    redirect_params(){
      if(!this.redirected){
        return '';
      }    

      let params = new URLSearchParams(window.location.search);
      params.delete('rdv_id');
      params.delete('redirected');
      return '?'+params+'&redirected=1';
    },    
  },
  methods: {
    logout() {
      this.$inertia.get("/auth/logout");
    },
    toggleModal(id) {
      let modal = document.querySelector(id);
      modal.classList.toggle("is-active");
    },
    toggleMenu() {
      let navbar_burger = document.querySelector(".navbar-burger");
      navbar_burger.classList.toggle("is-active");
      let menu = document.querySelector(".navbar-menu");
      menu.classList.toggle("is-active");
    },
    onUserLogin() {
      Inertia.reload({ only: ["auth.user"] });
      console.log('user',this.user);
    },
    get_redirected_params(){
      if(!this.redirected){
        return null;
      }

      let all_params = new URLSearchParams(window.location.search);
      let params = all_params.get('all_params_redirect');
      if(params != null){
        return JSON.parse(atob(params));
      }
      return null;
    },
    redirect(id_container, form) {
        console.log('in redirect');
        
        let container = document.getElementById(id_container);
        console.log('container',container,form);
        
        container.insertAdjacentHTML('afterbegin',form);
        let redirect_form = document.getElementById('rdv_redirect_form');
        redirect_form.submit();

        console.log('redirect element',redirect_form);
        
    },
    cancel_redirect_rdv(){
        if(this.redirected){
            let data = {};
            let params = this.get_redirected_params();
            console.log('cancel_redirect_rdv params',params);
            
            if(typeof params == 'object'){
              data.reservation_statut = 'ABANDON';
              data.ext_prestation_id = params.ext_prestation_id;
              
              if(typeof params.cancel_url == 'string' && params.cancel_url.length > 0) {data.cancel_url = params.cancel_url;}
              console.log('data to get form', data);
              
              axios
                    .post('/redirect/form/cancel',data)
                    .then((response) => {
                        this.redirect('layout_nav',response.data);
                    })
                    .catch((error) => {
                      toast({
                        message: this.$page.props.flash.message,
                        type: "is-danger",
                        duration: 5000,
                        pauseOnHover: true,
                      });
                    });
            }
            else{
              toast({
                    message: 'Paramètres de redirection manquantes',
                    type: "is-danger",
                    duration: 5000,
                    pauseOnHover: true,
                  });
                  this.$inertia.get(this.withAuth ? '/account'+this.redirect_params : '/');
            }
        }else{
            this.$inertia.get(this.withAuth ? '/account'+this.redirect_params : '/');
        }
    }
  },
  mounted() {
    console.log(this.$page);
    if (this.$page.props.flash.message && !(this.config && this.config['confirm_web_rdv'] == 1) && !this.redirected) {
      toast({
        message: this.$page.props.flash.message,
        type: "is-success",
        duration: 5000,
        pauseOnHover: true,
      });
    }
  },
};
</script>
